<template>
  <div
    class="lesson-list-wrap"
    :class="{
      'electron-lesson-list-wrap': isElectron,
    }"
  >
    <el-collapse v-if="unitList.length" v-model="activeNames">
      <el-collapse-item
        v-for="(unit, unitIndex) in unitList"
        :key="unit.unit_id"
        :title="unit.unit_name"
        :name="unit.unit_id"
      >
        <template slot="title">
          <div class="unit-name">
            {{ unit.unit_name }}
          </div>
        </template>
        <ul
          v-if="unit.lesson_list && unit.lesson_list.length"
          class="lesson-list"
        >
          <li
            v-for="(lesson, lessonIndex) in unit.lesson_list"
            :key="lesson.lesson_id"
          >
            <!-- 直播课 -->
            <div
              v-if="[2, 4].includes(lesson.lesson_type)"
              class="lesson-wrap"
              @click="jumpVideoPlay(lesson)"
            >
              <!-- 左 -->
              <div class="left-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span
                    v-if="lesson.roomStatus === 2"
                    class="lesson-type-tag living"
                  >
                    <img
                      src="../../../../assets/images/product-details/live.gif"
                      alt=""
                  /></span>
                  <span
                    v-else
                    class="lesson-type-tag"
                    :class="{ 'live-tag': lesson.liveStatus != 1 }"
                  >
                    {{ [1].includes(lesson.liveStatus) ? "视频" : "直播" }}
                  </span>
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span
                    :class="{ 'room-status2': lesson.roomStatus === 2 }"
                    class="room-status"
                    >{{ lesson.roomStatusText }}</span
                  >
                  <span class="separate"></span>
                  <span class="duration">
                    {{
                      moment(lesson.live_start_time * 1000).format(
                        "YYYY.MM.DD HH:mm"
                      )
                    }}
                    - {{ moment(lesson.live_end_time * 1000).format("HH:mm") }}
                  </span>
                  <span class="separate"></span>
                  <!-- 私教课-老师信息 -->
                  <el-tooltip
                    v-if="lesson.lesson_type === 4"
                    popper-class="moguo-tooltip"
                    class="item"
                    effect="dark"
                    :content="lesson.teachers"
                    placement="top"
                    :disabled="!lesson.isShowTooltip"
                  >
                    <span
                      class="teacher"
                      @mouseenter="
                        visibilityChange($event, lesson, unitIndex, lessonIndex)
                      "
                    >
                      {{ lesson.teachers }}
                    </span>
                  </el-tooltip>
                  <span v-else class="teacher">
                    {{ lesson.teacher_nickname }}
                  </span>
                  <span
                    v-if="lastStudyLesson.lesson_id === lesson.lesson_id"
                    class="last-study-tag"
                    >上次学到
                  </span>
                </div>
              </div>
              <!-- 右 -->
              <div class="right-operation-wrap">
                <el-button
                  v-if="lesson.liveStatus === 1"
                  class="text-btn"
                  size="small"
                  type="text"
                  >观看视频</el-button
                >
                <button
                  v-else-if="lesson.liveStatus === 3"
                  class="join-room-btn"
                >
                  <img
                    src="../../../../assets/images/living-white.gif"
                    alt=""
                  />
                  进入直播
                </button>
                <span v-else class="tips-text">{{ lesson.tips }} </span>
              </div>
            </div>
            <!-- 点播课 -->
            <div
              v-else-if="lesson.lesson_type === 1"
              @click="jumpVideoPlay(lesson)"
              class="lesson-wrap"
            >
              <div class="left-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span class="lesson-type-tag saas-demand-color">视频</span>
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="status">{{
                    studyStatus[lesson.study_status] || "未学习"
                  }}</span>
                  <span class="separate"></span>
                  <span class="duration">
                    {{ handleDuration(lesson.duration) }}
                  </span>
                  <span
                    v-if="lastStudyLesson.lesson_id === lesson.lesson_id"
                    class="last-study-tag"
                    >上次学到
                  </span>
                </div>
              </div>
              <div class="right-operation-wrap">
                <el-button class="text-btn" size="small" type="text"
                  >观看视频</el-button
                >
              </div>
            </div>
            <!-- 作业 -->
            <div
              v-else-if="lesson.work_info"
              class="lesson-wrap"
              @click="goHomeWorkPage(lesson.work_info)"
            >
              {{ handleBtnText(lesson) }}
              <div class="left-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ lessonIndex + 1 }}</span>
                  <span class="lesson-type-tag saas-homework-color">作业</span>
                  <span class="lesson-name">{{
                    lesson.work_info.homework_name
                  }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="status">{{
                    lesson.work_info && lesson.work_info.status > 1
                      ? "已完成"
                      : "未完成"
                  }}</span>
                  <span class="separate"></span>
                  <span v-if="lesson.work_end_time" class="duration"
                    >限{{
                      moment(lesson.work_end_time * 1000).format("YYYY-MM-DD")
                    }}前完成</span
                  >
                  <span v-else class="duration">不限时</span>
                </div>
              </div>
              <div class="right-operation-wrap">
                <span class="text-btn">{{ lesson.work_info.statusText }} </span>
              </div>
            </div>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import { isHXApp } from "@saas/components/src";
import { joinLiveRoom } from "@saas/components";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { getUserToken } from "@saas/server-api/src/live-list";
import { handleDuration } from "@saas/components/src/utils/utils";
import { checkLesson } from "@saas/server-api/src/learning-center";
import { getToken, getRefreshToken } from "@saas/server-api/src/plugins/auth";
import moment from "moment";
export default {
  props: {
    unitList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    lastStudyLesson: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      activeNames: [],
      moment,
      handleDuration,
      studyStatus: {
        0: "未学习",
        1: "学习中",
        2: "已学完",
      },
      isHXApp: isHXApp(),
      isElectron: window.isElectron,
    };
  },
  created() {
    if (window.isElectron) {
      // window.ipcRenderer.on("join-live-room-over", this.stopLoading);
    } else {
      window.addEventListener("join-live-room-over", this.stopLoading, true);
    }
  },
  beforeDestroy() {
    window.removeEventListener("join-live-room-over", this.stopLoading, true);
    // window?.ipcRenderer?.removeListener(
    //   "join-live-room-over",
    //   this.stopLoading
    // );
  },
  watch: {
    unitList: {
      handler: function (newVal) {
        if (!newVal.length) return;
        let activeId = newVal[0]?.unit_id; // 默认展开第一项
        // lesson_id参数
        let lesson_id = this.$route.query.lesson_id;
        if (lesson_id) {
          for (let index = 0; index < newVal.length; index++) {
            const unit = newVal[index];
            if (unit?.lesson_list?.length) {
              for (let i = 0; i < unit.lesson_list.length; i++) {
                const lesson = unit.lesson_list[i];
                if (lesson?.lesson_id === Number(lesson_id)) {
                  activeId = lesson.unit_id;
                  break;
                }
              }
            }
          }
        }
        if (activeId) {
          this.activeNames = [activeId];
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
  methods: {
    visibilityChange(event, lesson, unitIndex, lessonIndex) {
      if (lesson.isShowTooltip !== undefined) return;
      const ev = event.target;
      let ev_size = ev.scrollWidth;
      let content_size = ev.clientWidth;
      if (ev_size > content_size) {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          true
        );
      } else {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          false
        );
      }
    },
    // 跳转视频播放页
    jumpVideoPlay(lesson) {
      let { course_id, lesson_id, unit_id, id } = lesson;
      let lessonId = lesson_id || id;
      this.$router.push({
        path: `/video-play/${course_id}/${unit_id}/${lessonId}`,
      });
    },
    stopLoading() {
      console.log("stopLoading--1");
      this.$emit("pageLoading", false);
    },
    goHomeWorkPage(workInfo) {
      let { id, answer_type } = workInfo;
      if (answer_type === 1) {
        this.$router.push(`/homework/${id}`);
      } else if (answer_type === 2) {
        this.$router.push(`/homework-custom/${id}`);
      }
    },
    handleBtnText(lesson) {
      let time = lesson.work_end_time;
      let { status } = lesson.work_info || {};
      if (!status || status === 1) {
        // 未提交
        let now = new Date().getTime();
        if (time && time * 1000 < now) {
          lesson.workOvertime = 1;
          lesson.work_info.statusText = "超时未完成";
        } else {
          lesson.work_info.statusText = "写作业";
        }
      } else {
        lesson.work_info.statusText = "查看作业";
      }
    },
    handleLiveClick(lesson) {
      if (lesson.liveStatus === 1) {
        this.goReplay(lesson);
      } else if (lesson.liveStatus === 3) {
        this.goLiveRoom(lesson);
      } else if (lesson.roomStatus === 1) {
        this.$showToast("未开始");
      } else if (lesson.liveStatus === 2) {
        this.$showToast("回放生成中");
      }
    },
    // 进入教室
    goLiveRoom(obj) {
      this.$emit("pageLoading", true);
      let params = {
        course_id: obj.course_id,
        lesson_id: obj.lesson_id,
      };
      getUserToken(params).then((res) => {
        if (res.code === 1) {
          let {
            room_id = "",
            token = "",
            user_id = "",
            risk_control_switch,
            risk_control_config = {},
            is_teacher = false,
          } = res.data;
          let { course_id = "", lesson_id = "", unit_id = "" } = obj;
          const disableRecord =
            risk_control_switch === 1 &&
            risk_control_config.recording_screen_switch === 1
              ? 1
              : 0;
          if (this.isHXApp) {
            let params = {
              room_id,
              user_id,
              course_id,
              lesson_id,
              token,
              disableRecord,
            };
            jsToFlutter("joinLiveRoom", params);
            this.$emit("pageLoading", false);
          } else {
            this.$router.push({
              path: `/video-play/${course_id}/${unit_id}/${lesson_id}`,
            });
            this.$emit("pageLoading", false);
            // joinLiveRoom({
            //   classid: room_id,
            //   userid: user_id,
            //   courseid: course_id,
            //   lessonid: lesson_id,
            //   token: token,
            //   disableRecord: is_teacher ? 0 : disableRecord,
            // });
          }
        } else if (res.code === 40007) {
          // 开启网页防火墙
          this.$router.replace("/firewall/" + obj.course_id);
          this.$emit("pageLoading", false);
        } else {
          this.$message.error(res.message);
          this.$emit("pageLoading", false);
        }
      });
    },
    goReplay(obj) {
      checkLesson({ course_id: obj.course_id, lesson_id: obj.lesson_id }).then(
        (res) => {
          if (res.code === 1) {
            let { course_id, unit_id, lesson_id } = obj;
            this.$router.push({
              path: `/video-play/${course_id}/${unit_id}/${lesson_id}`,
            });
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.lesson-list-wrap {
  min-height: 400px;
  ::v-deep .el-collapse-item__arrow.el-icon-arrow-right.is-active {
    transform: rotate(-90deg);
  }
  ::v-deep .el-collapse-item__arrow.el-icon-arrow-right {
    transform: rotate(90deg);
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__header {
    height: 46px;
    background: $saas-bg-color;
    border-radius: 12px;
    border: none;
    padding: 12px 20px 12px 28px;
    font-weight: 400;
    font-size: 16px;
    color: $saas-text-color;
    line-height: 22px;
    .unit-name {
      white-space: nowrap;
      line-break: anywhere;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 95%;
    }
    i {
      color: $plain-text-color;
      font-size: 12px;
      font-weight: 600;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding: 0;
  }
  ::v-deep .el-collapse-item__wrap {
    border: none;
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 16px;
  }
  .last-study-tag {
    font-weight: 400;
    font-size: 12px;
    color: #ff4a26;
    line-height: 17px;
    margin-left: 20px;
  }
  .lesson-type-tag {
    display: inline-block;
    border-radius: 6px;
    border: 1px solid #efefef;
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    height: 22px;
    padding: 0 6px;
    background: #fff;
    width: auto;
    &.living {
      width: 40px;
      border: 1px solid #b8e7dd;
      padding-top: 3px;
      padding-bottom: 3px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &.live-tag {
      border: 1px solid #b8e7dd;
      color: #00c89d;
    }
  }
  .lesson-wrap {
    cursor: pointer;
    padding: 16px 0 16px 4px;
    border-bottom: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // 左
    .left-info-wrap {
      flex: 1;
      .lesson-index {
        font-weight: 400;
        font-size: 16px;
        color: #858687;
        line-height: 22px;
        width: 22px;
      }
      .lesson-name-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
      .lesson-name {
        flex: 1;
        width: 0;
        margin-left: 8px;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .lesson-item-bottom {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #515350;
        line-height: 20px;
        margin-left: 22px;
        .teacher {
          width: 0;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .separate {
        width: 1px;
        height: 11px;
        background: #efefef;
        border-radius: 1px;
        margin: 0 10px;
      }
      .room-status2 {
        background: linear-gradient(
          41.94400710581127deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    // 右
    .right-operation-wrap {
      display: flex;
      justify-content: flex-end;
      min-width: 147px;
      margin-left: 10px;
      .join-room-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 30px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 15px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 18px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }
      }
      .text-btn {
        font-weight: 400;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
      }
      .tips-text {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
  }
  .lesson-list > li {
    padding: 0 4px;
    &:hover {
      background: #f7f8fa;
    }
  }
  .lesson-list > li:last-child {
    .lesson-wrap {
      border-bottom: none;
    }
  }
}
.electron-lesson-list-wrap.lesson-list-wrap {
  ::v-deep .el-collapse-item__header {
    height: 44px;
    padding: 12px 20px 12px 28px;
    font-size: 14px;
    line-height: 20px;
    i {
      font-size: 10px;
    }
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 12px;
  }
  .lesson-type-tag {
    font-size: 12px;
    line-height: 18px;
    height: 20px;
  }
  .lesson-wrap {
    padding: 12px 0;
    // 左
    .left-info-wrap {
      flex: 1;
      .lesson-name-wrap {
        margin-bottom: 6px;
      }
      .lesson-name {
        font-size: 14px;
        line-height: 20px;
        margin-left: 6px;
      }
      .lesson-item-bottom {
        font-size: 12px;
        line-height: 17px;
      }
    }
    // 右
    .right-operation-wrap {
      text-align: right;
      min-width: 150px;
      margin-left: 10px;
      .join-room-btn {
        font-size: 14px;
        line-height: 20px;
      }
      .text-btn {
        font-size: 14px;
        line-height: 20px;
      }
      .tips-text {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .lesson-list > li {
    padding: 0 8px;
  }
}
</style>
